import React, { PureComponent } from 'react';
import { Translate } from 'react-localize-redux';
import styled from 'styled-components';

import Heading, { SubHeading } from '../../components/heading';
import WARNING from './warning.svg';

/**
 * Number of warnings to display
 * Must correspond with locale file
 */
const numberOfWarnings = 12;

const Container = styled.div`
  background: #181818;
  border-radius: 0.3em;
  padding: 2em 0.6em 1.5em;
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 90%;
  max-width: 50em;
  margin: 4em auto;
  @media (max-width: 767px) {
    flex-direction: column;
  }
`;

const Info = styled.div`
  text-align: center;
  flex: 4;
`;

const List = styled.ol`
  flex: 6;
`;

const Text = styled.li`
  letter-spacing: 0.1em;
  text-align: left;
  margin: 0.7em 0;
  font-size: 0.9em;
  color: #e0e0e0;
`;

const Image = styled.img`
  height: 4em;
  width: 4em;
  object-fit: cover;
  margin-bottom: 1em;
`;

/**
 * Warning section
 */
class Warning extends PureComponent {
  getWarnings() {
    const warnings = [];
    for (let warning = 0; warning < numberOfWarnings; warning++) {
      warnings.push(
        <Text key={warning}>
          <Translate id={`landingPage.warning.${warning + 1}`} />
        </Text>
      );
    }
    return warnings;
  }

  render() {
    return (
      <Container>
        <Info>
          <Image src={WARNING} />
          <Heading>NOTICE</Heading>
          <SubHeading>
            <Translate id="landingPage.warning.subtitle" />
          </SubHeading>
        </Info>
        <List>{this.getWarnings()}</List>
      </Container>
    );
  }
}

export default Warning;
